import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ items }) => (
  <div data-testid="editorial-marquee" className="border-y border-navy/10 bg-white py-8 overflow-hidden">
    <Marquee speed={26} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={item} className="flex items-center">
          <span className="font-heading italic text-3xl sm:text-4xl text-navy/15 px-6 whitespace-nowrap">
            {item}
          </span>
          <span className="w-2 h-2 rounded-full bg-accent/40 mx-2" />
        </span>
      ))}
    </Marquee>
  </div>
);
